// app/javascript/services/toast.js

// Materialize writes a string `html` option into innerHTML, so messages that
// carry user or server text (flash, API errors) would be parsed as markup.
// An element node is appended as-is, so the message is always shown as text.
export function toastText(message, classes) {
  const span = document.createElement('span');
  span.textContent = String(message);
  M.toast({ html: span, classes });
}

export const ToastService = {
  error(message) {
    if (!message) return;
    // Check if toast container exists and cleanup
    const existingToasts = document.querySelectorAll('.toast');
    existingToasts.forEach(toast => M.Toast.dismissAll());

    // Use existing Materialize instance
    toastText(message, 'red darken-1');
  },

  success(message) {
    if (!message) return;
    const existingToasts = document.querySelectorAll('.toast');
    existingToasts.forEach(toast => M.Toast.dismissAll());

    toastText(message, 'success-toast');
  }
}
